import axios from '@/jslib/axios'

export const getNesLetterList= params => {
  return axios({
    method: 'get',
    url: '/admin/subscriber/list',
    params
  })
}

export const resubscribe = data => {
  return axios({
    method: 'post',
    url: '/admin/subscribe/email',
    data
  })
}

export const unsubscribe = data => {
  return axios({
    method: 'post',
    url: '/admin/unsubscribe/email',
    data
  })
}

export const exportSubscribeList = params => {
  return axios({
    method: 'get',
    url: 'admin/subscriber/export',
    responseType: 'blob',
    params
  })
}